import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0f0f0f",
              border: "1px solid rgba(197,160,89,0.25)",
              color: "#f5f5f0",
              fontFamily: "Outfit, sans-serif",
              fontSize: "0.85rem",
              letterSpacing: "0.02em",
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
